export default {  
    argentina:{
        codigoDuasLetras: "AR",
        codigo: "ARG"
    }, 
    uruguai:{
        codigoDuasLetras: "UY",
        codigo: "URY"
    },    
    peru:{
        codigoDuasLetras: "PE",
        codigo: "PER"
    },  
    equador:{
        codigoDuasLetras: "EC",
        codigo: "ECU"
    },       
    mexico:{
        codigoDuasLetras: "MX",
        codigo: "MEX"
    },
    estadosUnidos:{
        codigoDuasLetras: "US",
        codigo: "USA"
    },
    brasil:{
        codigoDuasLetras: "BR",
        codigo: "BRA"     
    }, 
    colombia:{
        codigoDuasLetras: "CO",
        codigo: "COL"
    },   
    costaRica:{
        codigoDuasLetras: "CR",
        codigo: "CRI"
    },                   
    panama:{
        codigoDuasLetras: "PA",
        codigo: "PAN"
    },   
    chile:{
        codigoDuasLetras: "CL",
        codigo: "CHL"
    }          
}